export default class BatchAnimation {
    selector = `
        .wp-block-cinetic-creatives-blocks-title:not(.split-animated),
        .wp-block-cinetic-creatives-blocks-text,
        .wp-block-cinetic-creatives-blocks-person,
        .wp-block-cinetic-creatives-blocks-call-to-action:not(.home-hero-cover .wp-block-cinetic-creatives-blocks-call-to-action),
        .wp-block-cinetic-creatives-blocks-movie,
        .wp-block-cinetic-creatives-blocks-awards h2,
        .wp-block-cinetic-creatives-blocks-awards figure,
        .post-preview-item,
        .wp-block-cinetic-creatives-blocks-project-info .has-x-small-font-size,
        .wp-block-cinetic-creatives-blocks-project-info .has-small-font-size,
        .wp-block-cinetic-creatives-blocks-project-info .has-medium-font-size,
        .wp-block-cinetic-creatives-blocks-project-info .more-button,
        .wp-block-cinetic-creatives-blocks-media-grid figure,
        .wp-block-cinetic-creatives-blocks-quote
    `
    constructor({ el }) {        
        this.el = el
        gsap.set(this.el.querySelectorAll(this.selector), { 
            autoAlpha: 0
        });


    }

    apply() {

        this.st = ScrollTrigger.batch(this.el.querySelectorAll(this.selector), {
            once: true,
            onEnter: batch => gsap.to(batch, {
                autoAlpha: 1, 
                y: 0, 
                stagger: 0.05, 
                overwrite: true,
                duration: 0.5,
                ease: "power2.out"
            }),
            onLeave: batch => gsap.set(batch, { autoAlpha: 1, overwrite: true }),
            markers: false,
            
            start: "top 85%", 
        });
    }

    dispose() {
        this.st.kill()
    }
}